import React, { useEffect, useState } from 'react';
import { DefaultRootState, useDispatch, useSelector } from 'react-redux';
import { Spinner } from '../../components/UI';
import {
    Button,
    Paper,
    Box,
    Typography,
    makeStyles,
    IconButton,
    Tooltip,
    TablePagination,
} from '@material-ui/core';
import { QC_LEADS_APP_URL } from '../../config/env/env';
import useQCLeadsStyles from '../qc-leads/useQCLeadsStyles';
import IframeContainer from '../../components/IframeContainer/IframeContainer';
import { getUserToken } from '../../utils/helper';
import { buildIframeUrl } from '../../utils/appHelper';

interface QCLeadsPageProps {
    [key: string]: any;
}
const QCLeadsPage: React.FC = ({
    heliosTrackingData = [],
    staffTrackAndTrace,
    ...props
}: QCLeadsPageProps) => {
    //store values
    const token = getUserToken?.();
    const iframeSrc = buildIframeUrl(
        QC_LEADS_APP_URL,
        window.location.pathname.replace('/iframe', ''),
        token,
    );
    const { user, staff, settings } = useSelector(
        (store: DefaultRootState | any) => store || {},
    );

    //State values
    const [loading, setLoading] = useState(false);
    const [containerHeight, setContainerHeight] = useState(0);

    //hooks
    const dispatch = useDispatch();
    const containerRef = React.useRef<HTMLElement>(null);
    const classes = useQCLeadsStyles({
        containerHeight: containerHeight,
    });
    useEffect(() => {
        if (!!containerRef?.current?.offsetHeight && !containerHeight) {
            const height = containerRef.current.offsetHeight;
            setContainerHeight(height);
        }
    }, [containerRef?.current?.offsetHeight, containerHeight]);
    const handleLoading = (value: boolean) => {
        setLoading(value);
    };
    return (
        <Spinner loading={loading}>
            <Paper
                ref={containerRef}
                style={{ padding: '.1rem' }}
                className={classes.container}
                elevation={0}
            >
                {/* Iframe Content */}
                {!!iframeSrc ? (
                    <div
                        style={{ flex: 1, height: '100%', overflow: 'hidden' }}
                    >
                        <IframeContainer
                            src={iframeSrc}
                            title="QCLeads Dashboard"
                            sandbox="allow-scripts allow-forms allow-popups allow-downloads allow-same-origin"
                        />
                    </div>
                ) : (
                    <Typography variant="h6" style={{ padding: 16 }}>
                        QC Leads App URL is not configured.
                    </Typography>
                )}
            </Paper>
        </Spinner>
    );
};
export default QCLeadsPage;
